module.exports = __webpack_public_path__ + "static/liva-site-preview-b7e1c0928eb9d7b89badf0310915b90f.png";